import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

interface WorkoutData {
  week: number;
  date: string;
  workouts_count: number;
}

interface WorkoutsChartProps {
  data: WorkoutData[];
}

const WorkoutsChart: React.FC<WorkoutsChartProps> = ({ data }) => {
  // Сортируем данные по дате
  const sortedData = [...data].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  // Форматируем данные для Recharts
  const chartData = sortedData.map(item => {
    const date = new Date(item.date);
    const weekStart = new Date(date);
    weekStart.setDate(date.getDate() - date.getDay() + 1); // Понедельник
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6); // Воскресенье
    
    return {
      week: item.week,
      workouts_count: item.workouts_count,
      weekLabel: `Нед. ${item.week}`,
      weekRange: `${format(weekStart, 'dd.MM', { locale: ru })}-${format(weekEnd, 'dd.MM', { locale: ru })}`,
      originalDate: item.date
    };
  });

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-medium text-gray-900">{data.weekRange}</p>
          <p className="text-blue-600">
            Тренировок: <span className="font-semibold">{payload[0].value}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="mb-2">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">График тренировок</h3>
        <div className="flex flex-wrap gap-4 text-sm text-gray-600">
          <span>Записей: {data.length}</span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={chartData} margin={{ top: 10, right: 10, left: 5, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="weekLabel" 
            angle={-45}
            textAnchor="end"
            height={40}
            tick={{ fontSize: 10 }}
            stroke="#6b7280"
          />
          <YAxis 
            tick={{ fontSize: 11 }}
            stroke="#6b7280"
            domain={[0, 'dataMax + 1']}
            width={35}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar 
            dataKey="workouts_count" 
            fill="#3b82f6" 
            radius={[2, 2, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WorkoutsChart; 